import { useState, useEffect } from 'react';
import { subscribeToToasts, dismissToast, type Toast } from '@/utils/errorHandler';
import { AlertTriangle, XCircle, X, RefreshCw } from 'lucide-react';

export function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return subscribeToToasts(setToasts);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-start gap-3 p-3 rounded-lg shadow-lg border animate-fade-in ${
            toast.level === 'critical'
              ? 'bg-red-950 border-red-800 text-red-200'
              : toast.level === 'error'
              ? 'bg-red-950/80 border-red-900 text-red-200'
              : 'bg-yellow-950/80 border-yellow-900 text-yellow-200'
          }`}
        >
          {toast.level === 'warning' ? (
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
          ) : (
            <XCircle className="w-4 h-4 mt-0.5 shrink-0" />
          )}
          <div className="flex-1 min-w-0">
            <p className="text-sm">{toast.message}</p>
            {toast.retry && (
              <button
                onClick={() => {
                  toast.retry?.();
                  dismissToast(toast.id);
                }}
                className="flex items-center gap-1 mt-1.5 text-xs opacity-80 hover:opacity-100 transition-opacity"
              >
                <RefreshCw className="w-3 h-3" />
                Riprova
              </button>
            )}
          </div>
          <button
            onClick={() => dismissToast(toast.id)}
            className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
